import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography, Chip } from "@material-ui/core";

export const SummaryHeader = ({ classes, rows, transactionsCreated, timestamp }) => {
	const translate = useTranslate();

	return (
		<Box className={classes.summaryHeader}>
			{rows.map((row) => (
				<Box className={classes.summaryRow} key={row.label}>
					<Typography className={classes.summaryLabel}>{row.label}</Typography>
					<Typography className={classes.summaryValue}>{row.value}</Typography>
				</Box>
			))}
			<Box className={classes.summaryRow}>
				<Typography className={classes.summaryLabel}>
					{translate("resources.storage-transactions.dialogs.transactions_created")}
				</Typography>
				<Chip label={transactionsCreated} size="small" className={classes.summaryChip} />
			</Box>
			<Typography className={classes.timestamp}>{timestamp}</Typography>
		</Box>
	);
};
